import React from 'react';
import { connect } from 'react-redux';

export default function PerformanceSummary(props) {
  const { room } = props;

  return(
    <div></div>
  );
}